import { Checkbox } from '@ontruck/orc';
import { useCallback, useState } from 'react';
import * as http from 'utils/http';
import config from 'config';
import HighPrioTag from '../HighPrioTag';

const markShipperOrderAsHighPriority = (shipperOrderId) => {
  return http.post(`${config.API_URL}mercury/shipper_orders/${shipperOrderId}/high_priority/`);
};

const markShipperOrderAsNoHighPriority = (shipperOrderId) => {
  return http._delete(`${config.API_URL}mercury/shipper_orders/${shipperOrderId}/high_priority/`);
};

const HighPrioCheckbox = ({ shipperOrderId, isHighPriority }) => {
  const [loading, setLoading] = useState(false);
  const [checked, setChecked] = useState(isHighPriority);

  const handleChange = useCallback(
    async (e) => {
      try {
        setLoading(true);
        const isChecked = e.target.checked;
        const markFn = isChecked
          ? markShipperOrderAsHighPriority
          : markShipperOrderAsNoHighPriority;
        await markFn(shipperOrderId);
        setChecked(isChecked);
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    },
    [shipperOrderId]
  );

  return (
    <Checkbox
      name="high_priority"
      label={<HighPrioTag />}
      size="M"
      disabled={loading}
      checked={checked}
      onChange={handleChange}
    />
  );
};

export default HighPrioCheckbox;
